export const liquidValidationDelay = 300

export const liquidBlockedTags = ['include', 'render', 'layout']
